import React, { useEffect } from 'react';
import styles from './FiltroGrupoUsuario.module.css';
import { useQuery } from 'react-query';
import CampoMultiSeletor from '../Formulario/CampoMultiSeletor';

type FiltroGrupoUsuarioProps = {
  value: string[];
  onChange: (value: string[]) => void;

  disableQuery?: boolean;
  onQueryStatusChanged?: (
    status: 'loading' | 'error' | 'success' | 'idle',
  ) => void;
};

const FiltroGrupoUsuario = ({
  value,
  onChange,
  disableQuery,
  onQueryStatusChanged,
}: FiltroGrupoUsuarioProps) => {
  const queryGroups = useQuery(
    ['grupos'],
    async () => {
      const res = await fetch(`/api/usuario_grupo/box`);
      return res.json();
    },
    {
      staleTime: 1000 * 60 * 15,
      enabled: !disableQuery,
    },
  );

  useEffect(() => {
    onQueryStatusChanged?.(queryGroups.status);
  }, [queryGroups.status]);

  return (
    <CampoMultiSeletor
      placeholder={queryGroups.isLoading ? 'Carregando...' : 'Filtrar por Grupos / Departamentos'}
      options={
        queryGroups.data?.result?.map((it: any) => ({
          id: it.id.toString(),
          label: it.nome,
        })) ?? []
      }
      value={value}
      onChange={onChange}
      disabled={queryGroups.isLoading}
    />
  );
};

export default FiltroGrupoUsuario;
